module.exports = __webpack_public_path__ + "static/media/viewlist.648a32c1.svg";